var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bannerImg"},[_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.imgUrl,"alt":""}})]),_c('div',{staticClass:"text-box"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }